import { APP_COUNTRY } from 'config';
import media from 'style-utils/media-queries';
import { withOneLineEllipsis } from 'style-utils/overflow';
import { withSecondaryTypeface } from 'style-utils/text';
import styled from 'styled-components';

interface TopBarProps {
  isOverlayActive?: boolean;
}

export const TopBarRoot = styled.div<TopBarProps>`
  display: block;
  width: 100%;
  flex: 0 0 auto;
  margin-top: ${APP_COUNTRY === 'pt' ? '54px' : ''};
  padding: 40px 0 0;
  ////////////////// DROPDOWN //////////////////////
  position: relative;
  z-index: ${({ isOverlayActive }) => (isOverlayActive ? 1001 : 'auto')};
  transition: box-shadow 0.3s ease;

  ${media.desktop`
    padding: 50px 0 0;
  `};
`;

export const WithBannerTopBarRoot = styled(TopBarRoot)`
  position: fixed;
  left: 0;
  top: 88px;
  z-index: 101;
`;

export const SiteSection = styled.div<{ ios?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: ${({ ios }) => (ios ? 'flex-end' : 'space-between')};
  overflow: hidden;
  position: relative;
  z-index: 1;
  padding: 0 15px 0 8px;
  background: var(--site-section-bg);
  color: var(--site-section-text);
  height: 40px;
`;

export const AppHeading = styled.span`
  font-size: 16px;
  letter-spacing: 0.48px;
  font-weight: 900;
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  z-index: 2;
  ${withSecondaryTypeface};
  color: inherit;
  display: flex;
  align-items: center;
  justify-content: center;
  ${withOneLineEllipsis};
  width: 100%;
  pointer-events: none;
  text-align: center;
  margin: 0;
  padding: 0 15px 0 0;
`;

////////////////// DROPDOWN //////////////////////

export const DropdownShadow = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
`;
